export const brand = {
  name: "TriSphere",
  tagline: "The Digital Operating System for Education",
  descriptor: "TriSphere Group (U) LTD — one connected platform for payments, communication, finance, and digital services across the entire education ecosystem.",
  city: "Kampala",
  country: "Uganda",
  company: "TriSphere Group (U) LTD",
  domain: "trisphere.live",
};

export const subBrands = [
  { name: "TriSphere Pay", desc: "Payments" },
  { name: "TriSphere Wallet", desc: "Digital wallets" },
  { name: "TriSphere Market", desc: "School marketplace" },
  { name: "TriSphere Finance", desc: "Billing & reconciliation" },
  { name: "TriSphere Insights", desc: "Analytics & reporting" },
  { name: "TriSphere Connect", desc: "Parent & school communication" },
  { name: "TriSphere API", desc: "Developer platform" },
];
